<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import { Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

defineOptions({ layout: AppLayout })
defineProps({ drivers: { type: Array, default: () => [] } })

const { t } = useI18n()
</script>

<template>
  <PageShell :title="t('drivers.title')">
    <template #actions>
      <Link
        href="/drivers/new"
        class="ui-btn"
      >
        + {{ t('drivers.new') }}
      </Link>
    </template>
    <table class="drv-table">
      <thead>
        <tr>
          <th>{{ t('drivers.columns.name') }}</th>
          <th>{{ t('drivers.columns.phone') }}</th>
          <th>{{ t('drivers.columns.license_expiry') }}</th>
          <th>{{ t('drivers.columns.portal_access') }}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="d in drivers"
          :key="d.id"
        >
          <td>{{ d.name }}</td>
          <td>{{ d.phone || '—' }}</td>
          <td>
            {{ d.license_expiry || '—' }}
            <span
              v-if="d.license_status === 'expired'"
              class="pill pill--danger"
            >{{ t('drivers.license.expired') }}</span>
            <span
              v-else-if="d.license_status === 'expiring_soon'"
              class="pill pill--warn"
            >≤30d</span>
          </td>
          <td>
            <span :class="['pill', `pill--${d.portal_status}`]">{{ d.portal_status }}</span>
          </td>
          <td>
            <Link
              :href="`/drivers/${d.id}`"
              class="link"
            >
              {{ t('drivers.view') }}
            </Link>
          </td>
        </tr>
        <tr v-if="drivers.length === 0">
          <td
            colspan="5"
            class="empty"
          >
            {{ t('drivers.empty') }}
          </td>
        </tr>
      </tbody>
    </table>
  </PageShell>
</template>

<style scoped>
.drv-table { width: 100%; border-collapse: collapse; }
.drv-table th, .drv-table td { padding: 0.6rem 0.5rem; text-align: left; border-bottom: 1px solid var(--line); }
.drv-table th { font-size: 0.75rem; text-transform: uppercase; color: var(--muted); }
.pill { display: inline-block; padding: 0.15rem 0.5rem; border-radius: 999px; font-size: 0.75rem; margin-left: 0.4rem; }
.pill--active   { background: color-mix(in oklch, var(--ok) 16%, var(--surface)); color: var(--ok); }
.pill--disabled { background: color-mix(in oklch, var(--muted) 14%, var(--surface)); color: var(--muted); }
.pill--none     { background: color-mix(in oklch, var(--muted) 8%, var(--surface)); color: var(--muted); }
.pill--danger   { background: color-mix(in oklch, var(--danger) 14%, var(--surface)); color: var(--danger); }
.pill--warn     { background: color-mix(in oklch, var(--warn) 14%, var(--surface)); color: var(--warn); }
.empty { text-align: center; color: var(--muted); padding: 2rem; }
.link { color: var(--accent); text-decoration: none; }
.ui-btn { padding: 0.45rem 0.85rem; background: var(--accent); color: var(--accentInk); border-radius: var(--radius-button, 8px); text-decoration: none; font-weight: 500; }
</style>
